import _ from '@lodash';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import clsx from 'clsx';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/ComunicadorActions';

class ComunicadorNewButton extends XAPPComponent {

    cloneChildren = () => {
        const { children = null, openDialog, sugestao = {} } = this.props;
        if (React.isValidElement(children)) {
            return React.cloneElement(children, {
                onClick: () => { openDialog({ ...sugestao }) }
            });
        }
        return children;
    }

    render() {
        const { Comunicador = null, children = null } = this.props;
        return (
            <React.Fragment>
                {!_.isNull(children) && this.cloneChildren()}
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: Actions.openDialog,
    }, dispatch);
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user.data,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ComunicadorNewButton);
